import { useRef, useState } from "react";
import axios from "axios";
import toast, { Toaster } from "react-hot-toast";

// Split imports into their structurally correct react-icons sub-directories
import {
  FaCopy,
  FaCheckCircle,
  FaSpinner,
  FaCloudUploadAlt,
  FaInfoCircle,
  FaGlobe,
} from "react-icons/fa";

export default function RegistrationForm() {
  const [selectedPayment, setSelectedPayment] = useState("Bkash");
  const [selectedMember, setSelectedMember] = useState("Normal");
  const [isBangla, setIsBangla] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    amount: "",
    transactionId: "",
    image: null,
  });
  const fileInputRef = useRef(null);

  const paymentMethods = [
    { name: "Bkash", logo: "🔴", details: "01764632250", type: "Personal" },
    { name: "Nogod", logo: "orange", details: "01764632250", type: "Personal" },
    {
      name: "Card",
      logo: "💳",
      details: "Updating soon please use other options",
      type: "Disabled",
    },
    {
      name: "Bank",
      logo: "🏦",
      accountName: "Mudaraba Saving a/c",
      details: "20503040200399218",
      bankName: "Islami Bank Bangladesh PLC",
      branch: "O R Nizam road, Chattogram, Bangladesh",
    },
  ];

  const membershipPerks = {
    Normal: {
      titleBn: "General Life Member (সাধারণ আজীবন সদস্য) সুবিধাসমূহ :",
      titleEn: "General Life Member Benefits:",
      perksBn: [
        "কোনো মোমিন ব্যাক্তি / মোমিনা নারী নূন্যতম ৫০(পঞ্চাশ) হাজার টাকা বা সমপরিমান মসজিদ নির্মাণ সামগ্রী অনুদান প্রদান করিলে সাধারণ আজীবন সদস্য হিসাবে গণ্য হবেন।",
        "প্রত্যেক সাধারণ আজীবন সদস্য (General Life Member) এর জন্য একটি করে নামাজের স্থান (ভার্চুয়ালি) বরাদ্দ থাকবে। যার মাধ্যমে তিনি কেয়ামত পর্যন্ত পুন্য (ছোয়াব) পেতে থাকবেন।",
        "প্রত্যেক General Life Member (সাধারণ আজীবন সদস্য) কে সনদ (সার্টিফিকেট) প্রদান করা হবে ও নামাজের স্থানের অংকিত নকশা ক্রমিক নং সহ প্রদান করা হবে।",
      ],
      perksEn: [
        "Any Momin man or woman who contributes a minimum of 50,000 BDT or equivalent mosque construction materials will be recognized as a General Life Member.",
        "A virtual prayer space will be allocated for every General Life Member, serving as a source of continuous reward (Sadaqah Jariyah) until the Day of Judgment.",
        "Every General Life Member will be awarded an official Membership Certificate along with a numbered layout map of their virtual prayer space position.",
      ],
    },
    Premium: {
      titleBn: "Premium Life Member (বিশেষ আজীবন সদস্য) সুবিধাসমূহ :",
      titleEn: "Premium Life Member Benefits:",
      perksBn: [
        "কোনো মোমিন ব্যাক্তি / মোমিনা নারী ১ লক্ষ বা তার অধিক নগদ অর্থ বা সমপরিমান অর্থের মসজিদ নির্মাণ সামগ্রী অনুদান প্রদান করিলে বিশেষ আজীবন সদস্য হিসাবে গণ্য হবেন।",
        "প্রতি মাসের আয় ব্যয় এর হিসাব email এর মাধ্যমে সকল Premium Life Member (বিশেষ আজীবন সদস্য) গণকে পাঠানো হবে।",
        "দুই বছর অন্তর অন্তর মসজিদ পরিচালনা কমিটি গঠনের জন্য সকল প্রিমিয়াম লাইফ মেম্বার (বিশেষ আজীবন সদস্য) সদস্যগণ হতে মতামত ও পরামর্শ গ্রহণ করা হবে।",
        "প্রত্যেক প্রিমিয়াম লাইফ মেম্বার এর জন্য একটি করে নামাজের স্থান (ভার্চুয়ালি) বরাদ্দ থাকবে। যার মাধ্যমে তিনি কেয়ামত পর্যন্ত পুন্য (ছোয়াব) পেতে থাকবেন।",
        "প্রত্যেক প্রিমিয়াম লাইফ মেম্বার (বিশেষ আজীবন সদস্য) কে সনদ (সার্টিফিকেট) প্রদান করা হবে ও মেম্বারশিপ কার্ড  ক্রমিক নং সহ প্রদান করা হবে।",
        "ইসলামিক জীবনের বিশেষ বিশেষ মর্যাদাপূর্ণ রাত ও দিনের দোয়া মাহফিলে সকল আজীবন সদস্যদের পিতামাতা সহ পূর্বপুরুষ গণের জন্য বিশেষ ভাবে দোয়া করা হবে।",
      ],
      perksEn: [
        "Any Momin man or woman who contributes 100,000 BDT or more in cash or equivalent construction materials will be honored as a Premium Life Member.",
        "A monthly financial statement of income and expenses will be delivered directly via email to all Premium Life Members.",
        "Every two years, the valuable opinions and suggestions of all Premium Life Members will be sought for forming the Mosque Management Committee.",
        "A virtual prayer space will be designated for every Premium Life Member, ensuring continuous rewards (Sadaqah Jariyah) until eternity.",
        "Every Premium Life Member will receive an official framed Certificate along with the architectural design blueprint showing their allocated sequence number.",
        "Special prayers (Dua) will be dedicated for the parents and ancestors of all lifetime members during spiritually significant Islamic nights and days.",
      ],
    },
  };

  const currentMethod = paymentMethods.find((m) => m.name === selectedPayment);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  // Toast options config for custom, premium visual style
  const premiumToastOptions = {
    duration: 4000,
    style: {
      background: "#1c1917", // stone-900
      color: "#fafaf9", // stone-50
      borderRadius: "12px",
      fontSize: "13px",
      fontWeight: "600",
      letterSpacing: "0.2px",
      padding: "12px 18px",
      border: "1px solid rgba(250, 250, 249, 0.1)",
      boxShadow:
        "0 20px 25px -5px rgb(0 0 0 / 0.3), 0 8px 10px -6px rgb(0 0 0 / 0.3)",
    },
    success: {
      iconTheme: {
        primary: "#34d399", // emerald-400
        secondary: "#1c1917",
      },
    },
    error: {
      iconTheme: {
        primary: "#f87171", // red-400
        secondary: "#1c1917",
      },
    },
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!", premiumToastOptions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.name ||
      !formData.email ||
      !formData.phone ||
      !formData.amount ||
      !formData.transactionId
    ) {
      toast.error("Please fill in all required fields.", premiumToastOptions);
      return;
    }

    const phoneDigitsOnly = formData.phone.replace(/\D/g, "");
    if (phoneDigitsOnly.length !== 11 || formData.phone !== phoneDigitsOnly) {
      toast.error(
        "Phone number must be exactly 11 digits.",
        premiumToastOptions,
      );
      return;
    }

    // Checking validation constraints strictly based on tier rules
    const numericAmount = parseFloat(formData.amount);

    if (selectedMember === "Normal") {
      if (numericAmount < 50000 || numericAmount >= 100000) {
        toast.error(
          "General Life Membership requires an amount between 50,000 BDT and 99,999 BDT.",
          premiumToastOptions,
        );
        return;
      }
    } else if (selectedMember === "Premium") {
      if (numericAmount < 100000) {
        toast.error(
          "Minimum donation for Premium Life Membership is 100,000 BDT.",
          premiumToastOptions,
        );
        return;
      }
    }

    setIsSubmitting(true);

    try {
      let imageUrl = "";
      if (formData.image) {
        const imgData = new FormData();
        imgData.append("image", formData.image);

        const imgResponse = await axios.post(
          "https://api.imgbb.com/1/upload?key=486efa604b729a5151b5e18abca412d5",
          imgData,
        );
        imageUrl = imgResponse.data.data.url;
      }

      const payload = {
        membership: selectedMember,
        paymentMethod: selectedPayment,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        amount: formData.amount,
        transactionId: formData.transactionId,
        imageUrl,
        date: new Date().toLocaleDateString("en-CA"),
      };

      const response = await fetch(
        "https://mosque-backend-yfae.vercel.app/approveDonation",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(payload),
        },
      );

      await response.json();
      toast.success(
        "Registration Successful! Check your email for confirmation.",
        premiumToastOptions,
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        amount: "",
        transactionId: "",
        image: null,
      });
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong. Try again!", premiumToastOptions);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 items-start bg-white rounded-2xl border border-stone-200/60 p-6 md:p-8 shadow-xl relative overflow-hidden">
      <Toaster position="top-right" reverseOrder={false} />

      {isSubmitting && (
        <div className="absolute inset-0 bg-stone-950/40 backdrop-blur-sm z-50 flex flex-col items-center justify-center text-white gap-3 animate-fadeIn">
          <FaSpinner className="w-10 h-10 animate-spin text-emerald-400" />
          <p className="font-bold tracking-wide text-sm">
            Processing Registration Assets...
          </p>
        </div>
      )}

      {/* LEFT COLUMN: PERKS & PAYMENT PREVIEWS */}
      <div className="lg:col-span-7 space-y-6">
        <div>
          <span className="text-xs font-bold text-emerald-800 uppercase tracking-widest block mb-2">
            Step 1
          </span>
          <h3 className="text-lg font-bold text-stone-900 mb-3">
            Choose Membership Tier
          </h3>

          <div className="grid grid-cols-2 gap-3 bg-stone-100 p-1.5 rounded-xl border border-stone-200/40">
            {["Normal", "Premium"].map((type) => (
              <button
                key={type}
                type="button"
                className={`py-3 rounded-lg font-bold text-sm tracking-wide transition-all ${
                  selectedMember === type
                    ? "bg-green-950 text-white shadow-md"
                    : "text-stone-600 hover:text-stone-900 hover:bg-stone-200/60"
                }`}
                onClick={() => setSelectedMember(type)}
              >
                {type === "Normal" ? "General Life" : "Premium Life"}
              </button>
            ))}
          </div>
        </div>

        {/* Informative Perk Content Panel */}
        <div className="bg-gradient-to-br from-stone-50 via-stone-100/40 to-emerald-50/10 rounded-2xl border border-stone-200 p-5 relative">
          <button
            type="button"
            onClick={() => setIsBangla((prev) => !prev)}
            className="absolute top-4 right-4 text-xs font-bold bg-white text-stone-700 border border-stone-300 px-3 py-1.5 rounded-full inline-flex items-center gap-1.5 shadow-sm hover:bg-stone-50 transition-colors"
          >
            <FaGlobe className="text-emerald-700" />
            <span>{isBangla ? "English" : "বাংলা"}</span>
          </button>

          <div className="flex items-start gap-2.5 max-w-[80%] mb-4">
            <FaInfoCircle className="text-emerald-700 w-4 h-4 mt-0.5 shrink-0" />
            <h4 className="text-sm font-black text-green-950">
              {isBangla
                ? membershipPerks[selectedMember].titleBn
                : membershipPerks[selectedMember].titleEn}
            </h4>
          </div>

          <ul className="space-y-3">
            {(isBangla
              ? membershipPerks[selectedMember].perksBn
              : membershipPerks[selectedMember].perksEn
            ).map((perk, i) => (
              <li
                key={i}
                className="flex items-start gap-2.5 text-xs font-medium text-stone-700 leading-relaxed"
              >
                <FaCheckCircle className="text-emerald-600 w-3.5 h-3.5 mt-0.5 shrink-0" />
                <span>{perk}</span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <span className="text-xs font-bold text-emerald-800 uppercase tracking-widest block mb-2">
            Step 2
          </span>
          <h3 className="text-lg font-bold text-stone-900 mb-3">
            Select Contribution Method
          </h3>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {paymentMethods.map((method) => (
              <button
                key={method.name}
                type="button"
                disabled={method.type === "Disabled"}
                onClick={() => setSelectedPayment(method.name)}
                className={`p-3 rounded-xl border font-bold text-xs flex flex-col sm:flex-row items-center justify-center gap-2 transition-all ${
                  method.type === "Disabled"
                    ? "opacity-40 cursor-not-allowed bg-stone-100 border-stone-200 text-stone-400"
                    : selectedPayment === method.name
                      ? "bg-green-950 text-white border-green-950 shadow-md"
                      : "bg-white border-stone-200 text-stone-700 hover:bg-stone-50"
                }`}
              >
                {method.name === "Bkash" && (
                  <span className="w-4 h-4 rounded-full bg-[#d12053] inline-block shrink-0" />
                )}
                {method.name === "Nogod" && (
                  <span className="w-4 h-4 rounded-full bg-[#f46f22] inline-block shrink-0" />
                )}
                {method.name !== "Bkash" && method.name !== "Nogod" && (
                  <span className="text-sm shrink-0">{method.logo}</span>
                )}
                <span>{method.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Specialized Financial Account View */}
        <div className="bg-stone-900 text-stone-100 p-5 rounded-xl shadow-inner border border-stone-950">
          <div className="flex items-center justify-between border-b border-stone-800 pb-2.5 mb-3">
            <h4 className="text-xs font-bold tracking-widest text-emerald-400 uppercase">
              Official Target Gateway ({currentMethod.name})
            </h4>
            {currentMethod.type !== "Disabled" && (
              <button
                type="button"
                onClick={() => copyToClipboard(currentMethod.details)}
                className="text-stone-400 hover:text-white transition-colors p-1"
                title="Copy Target ID"
              >
                <FaCopy size={14} />
              </button>
            )}
          </div>

          {currentMethod.name === "Bank" ? (
            <div className="space-y-1.5 text-xs">
              <p className="text-stone-400 font-medium">
                Account Type:{" "}
                <span className="text-stone-100 font-bold">
                  {currentMethod.accountName}
                </span>
              </p>
              <p className="text-base font-black tracking-wider text-white font-mono">
                {currentMethod.details}
              </p>
              <p className="text-emerald-400 font-bold">
                {currentMethod.bankName}
              </p>
              <p className="text-stone-400 italic">{currentMethod.branch}</p>
            </div>
          ) : (
            <div className="flex items-baseline justify-between">
              <span className="text-xl font-black font-mono tracking-wider text-white">
                {currentMethod.details}
              </span>
              <span className="text-[10px] font-bold uppercase tracking-wider bg-white/10 px-2 py-0.5 rounded text-stone-300">
                {currentMethod.type}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* RIGHT COLUMN: FORM FIELDS */}
      <form className="lg:col-span-5 space-y-4" onSubmit={handleSubmit}>
        <div className="border-b border-stone-100 pb-3 mb-2">
          <span className="text-xs font-bold text-emerald-800 uppercase tracking-widest block mb-1">
            Step 3
          </span>
          <h3 className="text-lg font-black text-stone-900">
            Applicant Details
          </h3>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-[11px] font-bold text-stone-500 uppercase tracking-wider mb-1">
              Full Name
            </label>
            <input
              className="w-full bg-stone-50 border border-stone-200 px-3 py-2.5 text-sm rounded-lg focus:outline-none focus:border-emerald-700 transition-colors"
              type="text"
              name="name"
              placeholder="e.g., Muhammad Ali"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label className="block text-[11px] font-bold text-stone-500 uppercase tracking-wider mb-1">
              Email Address
            </label>
            <input
              className="w-full bg-stone-50 border border-stone-200 px-3 py-2.5 text-sm rounded-lg focus:outline-none focus:border-emerald-700 transition-colors"
              type="email"
              name="email"
              placeholder="name@domain.com"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label className="block text-[11px] font-bold text-stone-500 uppercase tracking-wider mb-1">
              Phone Number (11 digits)
            </label>
            <input
              className="w-full bg-stone-50 border border-stone-200 px-3 py-2.5 text-sm rounded-lg focus:outline-none focus:border-emerald-700 transition-colors font-mono"
              type="tel"
              name="phone"
              maxLength={11}
              placeholder="01XXXXXXXXX"
              value={formData.phone}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label className="block text-[11px] font-bold text-stone-500 uppercase tracking-wider mb-1">
              Donation Amount (BDT{" "}
              {selectedMember === "Normal"
                ? "— Min. 50,000 to 99,999"
                : "— Min. 100,000"}
              )
            </label>
            <input
              className="w-full bg-stone-50 border border-stone-200 px-3 py-2.5 text-sm rounded-lg focus:outline-none focus:border-emerald-700 transition-colors font-bold text-green-950"
              type="number"
              name="amount"
              placeholder={
                selectedMember === "Normal"
                  ? "Min. 50000 - Max. 99999"
                  : "Min. 100000"
              }
              value={formData.amount}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label className="block text-[11px] font-bold text-stone-500 uppercase tracking-wider mb-1">
              Transaction Reference ID
            </label>
            <input
              className="w-full bg-stone-50 border border-stone-200 px-3 py-2.5 text-sm rounded-lg focus:outline-none focus:border-emerald-700 transition-colors font-mono tracking-wide"
              type="text"
              name="transactionId"
              placeholder="TRX-XXXX-XXXX"
              value={formData.transactionId}
              onChange={handleInputChange}
              required
            />
          </div>

          <div>
            <label className="block text-[11px] font-bold text-stone-500 uppercase tracking-wider mb-1">
              Profile Photo / Proof Slip
            </label>
            <div className="relative border-2 border-dashed border-stone-200 rounded-lg p-3 bg-stone-50 text-center hover:bg-stone-100/50 transition-colors cursor-pointer group">
              <input
                className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
              />
              <div className="flex flex-col items-center justify-center gap-1 text-stone-500">
                <FaCloudUploadAlt className="w-5 h-5 text-emerald-700 group-hover:scale-110 transition-transform" />
                <span className="text-xs font-semibold max-w-[180px] truncate">
                  {formData.image ? formData.image.name : "Upload image file"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <button
          className="w-full mt-6 bg-green-950 text-white py-3 rounded-xl font-bold tracking-wide text-sm shadow-md hover:bg-green-900 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-2"
          type="submit"
          disabled={isSubmitting}
        >
          <span>Submit Verification Application</span>
        </button>
      </form>
    </div>
  );
}
